import { useState } from "react";
import SideMenu from "../../components/admin/SideMenu";
import GroupLists from "../../components/admin/lists/GroupLists";
import GroupEdit from "../../components/admin/edit/GroupEdit";
import ExcelDownloadButton from "../../components/admin/lists/common/ExcelDownloadButton";
import { useGroups } from "../../hooks/useGroups";

const AdminGroups = () => {
  const [editUserId, setEditUserId] = useState<string | null>(null);
  const [isNew, setIsNew] = useState(false);
  const [selectedTab, setSelectedTab] = useState("QuartetContest");
  const [currentYear, setCurrentYear] = useState(() => {
    return Number(localStorage.getItem("currentYear")) || 2024;
  });

  const { groups, loading, fetchGroups } = useGroups();

  const handleEditUser = (userId: string) => {
    setEditUserId(userId);
    setIsNew(false);
  };

  const handleCreateNew = () => {
    setEditUserId(null);
    setIsNew(true);
  };

  const handleBack = () => {
    setEditUserId(null);
    setIsNew(false);
  };

  return (
    <div className="main-admin">
      <div className="flex">
        <SideMenu />

        <div className="main-contents">
          <h3>エントリー</h3>

          {!editUserId && !isNew && (
            <div className="list-header">
              <div className="tab">
                <button
                  className={`quartet ${
                    selectedTab === "QuartetContest" ? "active" : ""
                  }`}
                  onClick={() => setSelectedTab("QuartetContest")}
                >
                  Quartet Contest
                </button>

                <button
                  className={`chorus ${
                    selectedTab === "ChorusContest" ? "active" : ""
                  }`}
                  onClick={() => setSelectedTab("ChorusContest")}
                >
                  Chorus Contest
                </button>

                <button
                  className={`evaluation ${
                    selectedTab === "EvaluationOnly" ? "active" : ""
                  }`}
                  onClick={() => setSelectedTab("EvaluationOnly")}
                >
                  Evaluation Only
                </button>
              </div>

              <div className="header-button-area">
                <ExcelDownloadButton
                  groups={groups}
                  currentYear={currentYear}
                />

                <button
                  className="new-btn"
                  onClick={handleCreateNew}
                >
                  ＋ 新規登録
                </button>
              </div>
            </div>
          )}

          {editUserId || isNew ? (
            <GroupEdit
              userId={editUserId ?? undefined}
              onBack={handleBack}
            />
          ) : (
            <GroupLists
              groups={groups}
              loading={loading}
              onEdit={handleEditUser}
              selectedTab={selectedTab}
              currentYear={currentYear}
              setCurrentYear={setCurrentYear}
              onGroupsChanged={fetchGroups}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminGroups;